<script setup>
defineProps({
  to: {
    type: String,
    default: null,
  },
  href: {
    type: String,
    default: null,
  },
})
</script>

<template>
  <a :href="to" class="button" v-if="to">
    <slot />
  </a>
  <a :href="href" class="button" v-else-if="href">
    <slot />
  </a>
  <button type="button" class="button" v-else v-bind="$attrs">
    <slot />
  </button>
</template>

<style lang="scss" scoped>
.button {
  box-sizing: border-box;
  display: block;
  margin: 32px 0 0 0;
  border-radius: 24px;
  background: var(--primary-600, #183D4F);
  box-shadow: 0 4px 6px -4px rgba(16, 24, 40, 0.10), 0px 10px 15px -3px rgba(16, 24, 40, 0.10);
  color: var(--shades-white, #FFF);
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px; /* 125% */
  text-transform: uppercase;
  padding: 17px 24px;
  text-decoration: none;

  @media screen and (min-width: 768px) {
    border-radius: 32px;
    font-size: 20px;
    padding: 20px 96px;
    display: inline-block;
  }
}
</style>
